<template>
  <div data-app>
    <v-dialog
      v-model="trade_detail_form.flag"
      class="dialog"
      width="700"
      height="600"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-overlay absolute v-if="loading" class="text-center">
        <v-progress-circular indeterminate color="#2d8cff" class="mr-2 my-2" />
      </v-overlay>
      <div class="card" v-if="!loading">
        <UpdateReasoningForm
          @reload-trade-data="Reloading(trade_data.id)"
          :trade_detail="trade_data"
          :trade_reasoning="trade_reasoning"
          v-if="trade_reasoning.flag"
        />
        <div
          class="pa-4"
          style="
            font-size: 22px;
            display: flex;
            background-color: #2d8cff;
            color: white;
            font-weight: 800;
          "
        >
          Trade Details
          <v-spacer></v-spacer>
          <v-icon text @click="closeForm()" color="#fff" large style="cursor"
            >mdi-close
          </v-icon>
        </div>
        <div class="card-content">
          <trade-data
            :show_button="true"
            :trade_data="trade_data"
            :ref="`${trade_data.id}`"
            :showDivider="true"
            :is_user_content="true"
            :allowed_actions="allowed_actions"
            @reloadForm="getTrades"
            @delete-trade="deleteTrade"
            @now-reload-home="$emit('reload-home')"
            @reload-home-trades="getTradeDetails"
            @reloadTradeDetailForm="getTrades"
            @reload-home-trade="$emit('reload-trending-trades')"
            @update-reasoning="updateReasoning(trade_data.id)"
            @exitReload="$emit('exitReload')"
            @close="closeForm()"
          />
        </div>
        <div class="comments-title-div">
          <p class="comment-title">Comments</p>

          <v-form class="actions" ref="entryForm" @submit.prevent="addComment">
            <v-textarea
              placeholder="Write your comment here "
              height="55"
              :rules="rules"
              v-model="commentText"
              outlined
              required
              class="text__field"
            ></v-textarea>
            <v-spacer></v-spacer>
            <v-btn
              height="55"
              type="submit"
              color="#2D8CFF"
              id="first-comment"
              class="px-2 save__btn"
              >Add</v-btn
            >
          </v-form>
        </div>
        <div class="comment-container">
          <CommentCard :item="item" v-for="item in comments" :key="item.id" />
        </div>
        <div style="height: 20px; background: #f7faff"></div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import TradeData from "./TradeUserData.vue";
import CommentCard from "./CommentCard.vue";
import Axios from "@/api/BaseAxios.js";
import UpdateReasoningForm from "./UpdateReasoningForm.vue";
import { isAuthenticated } from "../../common/commonFunctions";
import { mapActions } from "vuex";
import apiUrl from "@/common/apiUrl";
import commonFunctions from "../../common/commonFunctions";
export default {
  name: "TradeDetailForm",
  props: ["trade_detail_form"],
  components: {
    CommentCard,
    TradeData,
    UpdateReasoningForm,
  },
  data: () => ({
    allowed_actions: [],
    trade_type: "",
    security: null,
    loading: false,
    securities: [],
    entry_price: 0,
    commentText: null,
    comments: [],
    rules: [],
    tooltip: false,
    hideOverlay: false,
    fullscreen: false,
    validUrl: null,
    trade_reasoning: {
      flag: false,
      id: "",
    },
    reasons: [
      {
        name: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Unde, mollitia.",
        time: "23 April, 2021",
      },
      {
        name: " ipsum dolor sit amet consectetur, adipisicing elit. Unde, mollitia.",
        time: "23 April, 2021",
      },
      {
        name: " dolor sit amet consectetur, adipisicing elit. Unde, mollitia.",
        time: "23 April, 2021",
      },
      {
        name: " sit amet consectetur, adipisicing elit. Unde, mollitia.",
        time: "23 April, 2021",
      },
      {
        name: " sit amet consectetur, adipisicing elit. Unde, mollitia.",
        time: "23 April, 2021",
      },
    ],
    sebi_badge: require("@/assets/images/gold_check.svg"),
  }),
  methods: {
    ...mapActions("snackBar", ["showSnack"]),

    closeForm() {
      this.trade_detail_form.flag = false;
    },
    scrollToComment() {
      document.getElementById("first-comment").scrollIntoView();
    },
    Reloading() {
      this.loading = true;
      this.getTradeDetails();
      // setTimeout(()=>{
      this.$emit("reload-trade-data", this.trade_detail_form.id);
      // }, 1000)
    },
    deleteTrade() {
      this.$emit("deleteTrades");
      this.closeForm();
    },
    getTrades() {
      this.$emit("reload-profile");
      // this.$emit('reload-trades')
      this.$emit("reload-trade-data");
    },
    getTradeDetails() {
      const successHandler = (res) => {
        this.trade_data = res.data;
        this.comments = this.trade_data.comments;
        if (this.trade_data.is_real) {
          this.getActions();
        }

        setTimeout(() => {
          this.loading = false;
        }, 500);
      };
      const errorHandler = (err) => {
        console.log(err);
        this.loading = false;
      };
      Axios.request_GET(
        `api/trade/user-trade-detail/${this.trade_detail_form.id}/`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        commonFunctions.IsAuth()
      );
    },
    getActions() {
      let params = {};
      let config = {};
      params["trade_id"] = this.trade_data.id;
      config["params"] = params;
      this.tempAxios
        .get(apiUrl.TRADE_ACTIONS, config)
        .then((res) => {
          console.log(res);
          console.log(res.data.action_list.length);
          if (res.data.action_list.length) {
            this.allowed_actions = res.data.action_list;
          }
          // console.log(
          //   typeof this.allowed_actions,
          //   "actions",
          //   this.allowed_actions
          // );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addComment() {
      console.log("add comment ");
      if (!isAuthenticated()) {
        this.showSnack({
          text: "Login to add comment here",
          color: "success",
          timeout: 4500,
        });

        return false;
      }
      this.rules = [(v) => !!v || "Field is required"];
      console.log(this.$refs.entryForm.validate());
      if (this.commentText) {
        const user_id = localStorage.getItem("profile_id");
        const data = {
          comment: this.commentText,
          user_id: user_id,
        };
        const successHandler = (res) => {
          console.log(res.data.message);
          this.commentText = null;
          this.comments = res.data;
          // this.loading = true;
          this.getTradeDetails();
          this.scrollToComment();
          setTimeout(() => {
            this.$emit("reload-trade-data-comment", this.trade_detail_form.id);
            this.$emit("reload-home-trade");
          }, 500);
        };
        const errorHandler = (err) => {
          console.log(err);
        };
        Axios.request_POST(
          `api/trade/update-comment/${this.trade_detail_form.id}/`,
          data,
          {},
          successHandler,
          errorHandler,
          false,
          false
        );
        this.rules = [];
      }
    },

    updateReasoning(id) {
      if (!isAuthenticated()) {
        if (!isAuthenticated()) {
          this.showSnack({
            text: "Login to add reasoning here",
            color: "success",
            timeout: 4500,
          });
          return;
        }
        return false;
      }
      this.trade_reasoning.flag = true;
      this.trade_reasoning.id = id;
    },
  },
  mounted() {
    this.loading = true;
    this.getTradeDetails();
    var w = window.innerWidth;
    if (w < 768) {
      setTimeout(() => {
        this.fullscreen = true;
        this.hideOverlay = true;
      }, 100);
    } else {
      this.fullscreen = false;
      this.hideOverlay = false;
    }
  },
};
</script>

<style></style>
<style scoped>
.card {
  min-height: 600px !important;
  background: #fff;
}
.profile-pic {
  display: inline-block;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  text-align: center;
}
.user-title {
  width: 80%;
  padding-left: 20px;
}
.user-content {
  display: flex;
  align-items: center;
  padding: 20px;
}
.follow-btn {
  display: flex;
  cursor: pointer;
  color: #2d8cff;
  font-weight: 800;
  font-size: 16px;
  align-items: center;
}

.title-and-chip {
  display: flex;
  padding: 10px 20px 0px 20px;
  margin: 0px;
  justify-content: space-between;
}
.title-span {
  font-size: 18px;
  font-weight: 700;
  color: black;
  width: 70%;
  font-weight: 900;
}
.custom-chip-buy {
  color: #2d8cff;
}
.custom-chip-sell {
  color: #eb5757;
}
.custom-chip-buy,
.custom-chip-sell {
  font-weight: 800;
  font-size: 16px;
  text-align: center;
  text-transform: uppercase;
}
.tooltip {
  color: #111111 !important;
  background: #f7faff;
  width: 10% !important;
}

.live-figures-div {
  display: flex;
  padding: 0px 20px !important;
  justify-content: space-between;
  align-items: center;
}
.figures {
  display: flex;
  width: 30%;
  align-items: center;
  justify-content: space-between;
}
.live-price {
  font-weight: 800;
  font-size: 24px;
}
.profit-percent,
.loss-percent {
  border-radius: 3px;
  padding-top: 8px;
  text-align: center;
  font-size: 13px !important;
  font-weight: bold;

  width: 70px !important;
}
.profit-percent {
  background: rgba(39, 174, 96, 0.12);
  color: #27ae60;
}
.increment {
  color: #27ae60;
}
.increment,
.decrement {
  padding-top: 5px;
  font-weight: 800;
  font-size: 12px;
  line-height: 16px;
}
.decrement {
  color: #eb5757;
}
.loss-percent {
  background: rgba(235, 87, 87, 0.2);
  color: #eb5757;
}
.figures-container {
  display: flex;
  padding: 20px;
  flex-direction: row;
  flex-wrap: wrap !important;
  width: 100% !important;
  justify-content: stretch;
}
.price {
  display: flex;
  flex: 0 0 33.333333%;
  flex-direction: column;
  justify-content: center;

  padding-top: 10px;
}
.price-span {
  color: rgba(51, 51, 51, 0.64) !important;
  font-size: 12px;
}
.reasoning {
  padding: 0px 20px;
}
.reason {
  font-weight: 500;
  font-size: 14px;
  color: #333333;
}
.reason-time {
  color: grey;
  font-size: 13px;
}
.figure {
  font-size: 18px;
  font-weight: 800 !important;
}
.comments-title-div {
  padding: 20px 20px;
  background: #f6f7fa;
}

.comment-title {
  font-weight: 900;
  font-size: 17px;
}
.comment-container {
  padding: 20px 20px;
}
.actions {
  display: flex;
  background: #f6f7fa;
}

.text__field {
  border-radius: 5px;
  background: #fff;
  height: 55px;
  width: 70%;
  border: 1px solid #f2f2f2;
}
.save__btn {
  text-transform: capitalize;
  color: #fff;
  letter-spacing: 0px;
  border-radius: 8px;
  box-shadow: 0px 1px 8px rgba(34, 123, 232, 0.14);
  width: 100px;
  font-size: 16px;
  font-weight: 800;
}
.cta-button {
  margin-left: 10px;
  text-transform: capitalize;
  color: #fff;
  letter-spacing: 0px;
  border-radius: 8px;
  box-shadow: 0px 1px 8px rgba(34, 123, 232, 0.14);
}
.cta-icon {
  border-radius: 8px;
  box-shadow: 0px 1px 8px rgba(34, 123, 232, 0.14);
  border: 1px solid #2d8cff;
}
.cta-button,
.cta-icon {
  margin: 0px 5px;
}
.cta-buttons {
  display: flex;
  border-top: 1px solid lightgray;
  justify-content: space-between;
  background: #fff;
  border-radius: 0px 0px 8px 8px;
  height: 50px;
}
.cta-btn {
  padding: 10px 5px;
  height: 50px;
  width: 33%;
  font-size: 14px;
  text-align: center;
  color: rgba(51, 51, 51, 0.7);
  border-left: 1px solid grey;
}
#sebi-tooltip {
  width: 10%;
  margin-left: 90px !important;
  background-color: lightblue;
}
#sebi-tooltip::after {
  content: " ";
  position: absolute;

  border-width: 10px;
  border-style: solid;
  border-color: transparent transparent lightblue transparent;
}
#sebi-tooltip {
  font-size: 13px;
  text-align: center;
  position: relative;
  z-index: 1;
  padding: 5px;
  border-radius: 6px;
  position: fixed;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
}

@media all and (max-width: 600px) {
  .comment-container,
  .comments-title-div {
    padding: 10px 14px !important;
  }
  .title-span {
    font-size: 16px;
  }
  .comment-title {
    font-size: 16px;
  }
  .trade-time,
  .user-name {
    font-size: 14px;
  }
  .price-span {
    font-size: 12px;
  }
  .caption {
    font-size: 15px !important;
  }
  .text__field {
    width: 100% !important;
    height: 55px;
  }
  .actions {
    padding-bottom: 10px !important;
  }
  .save__btn {
    width: 10px !important;
    margin-left: 10px;
  }
}
</style>
